import Vue from "vue";
import "vue-googlemaps/dist/vue-googlemaps.css";
// @ts-ignore
import VueGoogleMaps from "vue-googlemaps";
const google_api_key = "AIzaSyB251OTWfMluH17WoniiNzXe_4D23p3Xpo";
Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    apiKey: google_api_key,
    // Enable more Google Maps libraries here
    libraries: ["places"],
    // Use new renderer
    useBetaRenderer: false,
  },
});
